import { ref, onMounted, resolveComponent, createBlock, openBlock, unref, withCtx, createElementBlock, createVNode, toDisplayString } from "vue";
import { SYSTEM_SETTINGS, EDIT_SYSTEM_SETTINGS } from "../../graphql/system-settings.js";
import { useApolloGlobalClient } from "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useI18n } from "../../plugins/i18n.js";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import { VProgressCircular } from "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "tiny-emitter/instance";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
  key: 2,
  class: "d-flex flex-nowrap g-2"
};
const _sfc_main = {
  __name: "SystemSettingsSection",
  setup(__props) {
    const client = useApolloGlobalClient();
    const { t } = useI18n();
    const systemSettings = ref([]);
    const headers = ref([
      {
        title: t(
          "banza.components.system_settings.SystemSettingsSection.labels.code"
        ),
        key: "code"
      },
      {
        title: t(
          "banza.components.system_settings.SystemSettingsSection.labels.name"
        ),
        key: "name"
      },
      {
        title: t(
          "banza.components.system_settings.SystemSettingsSection.labels.value"
        ),
        key: "value"
      },
      { key: "actions", sortable: false }
    ]);
    const loadData = async () => {
      var _a;
      const { data } = await client.query({
        query: SYSTEM_SETTINGS
      });
      systemSettings.value = ((_a = data == null ? void 0 : data.systemSettings) == null ? void 0 : _a.items) || [];
    };
    const edit = (item) => {
      item.editableValue = item.value;
      item.isBeingEdited = true;
    };
    const onEditComplete = (item) => {
      item.isBeingEdited = false;
      delete item.editableValue;
    };
    const canSave = (item) => {
      return item.editableValue !== item.value;
    };
    const save = async (item) => {
      item.isSaving = true;
      client.mutate({
        mutation: EDIT_SYSTEM_SETTINGS,
        variables: {
          inputs: [
            {
              id: item.id,
              value: item.editableValue
            }
          ]
        }
      }).then(() => {
        item.value = item.editableValue;
      }).catch(console.error).finally(() => {
        onEditComplete(item);
        item.isSaving = false;
      });
    };
    onMounted(loadData);
    return (_ctx, _cache) => {
      const _component_b_text_edit = resolveComponent("b-text-edit");
      const _component_b_btn = resolveComponent("b-btn");
      const _component_b_section = resolveComponent("b-section");
      return openBlock(), createBlock(_component_b_section, {
        header: _ctx.$t("banza.components.system_settings.SystemSettingsSection.header"),
        headers: unref(headers),
        items: unref(systemSettings),
        "search-field": "code,name,value",
        "default-sort-by": [{ key: "name", order: "asc" }]
      }, {
        "item.value": withCtx(({ item }) => [
          !item.isBeingEdited ? (openBlock(), createElementBlock("span", _hoisted_1, toDisplayString(item.value), 1)) : (openBlock(), createBlock(_component_b_text_edit, {
            key: 1,
            modelValue: item.editableValue,
            "onUpdate:modelValue": ($event) => item.editableValue = $event
          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
        ]),
        "item.actions": withCtx(({ item }) => [
          item.isSaving ? (openBlock(), createBlock(VProgressCircular, {
            key: 0,
            color: "primary",
            indeterminate: "",
            size: 40
          })) : !item.isBeingEdited ? (openBlock(), createBlock(_component_b_btn, {
            key: 1,
            preset: "icon",
            "icon-name": "mdi-pencil",
            size: 40,
            onClick: ($event) => edit(item)
          }, null, 8, ["onClick"])) : (openBlock(), createElementBlock("div", _hoisted_2, [
            createVNode(_component_b_btn, {
              preset: "icon",
              "icon-name": "mdi-check",
              color: "success",
              size: 40,
              disabled: !canSave(item),
              onClick: ($event) => save(item)
            }, null, 8, ["disabled", "onClick"]),
            createVNode(_component_b_btn, {
              preset: "icon",
              "icon-name": "mdi-close",
              color: "error",
              size: 40,
              onClick: ($event) => onEditComplete(item)
            }, null, 8, ["onClick"])
          ]))
        ]),
        _: 1
      }, 8, ["header", "headers", "items"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
